import { render, staticRenderFns } from "./audit.vue?vue&type=template&id=32050051&scoped=true"
import script from "./audit.vue?vue&type=script&lang=js"
export * from "./audit.vue?vue&type=script&lang=js"
import style0 from "./audit.vue?vue&type=style&index=0&id=32050051&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32050051",
  null
  
)

export default component.exports